import React from 'react';
import { makeStyles } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const styles = makeStyles(({ palette }) => ({
  filled: {
    color: palette.common.white,
  },
  transparent: {
    color: palette.primary.main,
  },
  container: {
    padding: 0,
  },
}));

interface ArrowBackButtonProps {
  onClick: () => void;
  variant?: 'filled' | 'transparent' | 'transparentMenu';
}

const ArrowBackButton = ({ onClick, variant = 'filled' }: ArrowBackButtonProps) => {
  const classes = styles();

  return (
    <IconButton
      data-testid="go-back-button"
      onClick={onClick}
      size="small"
      className={`${classes[variant]} ${classes.container}`}
      aria-label="Go Back"
    >
      <ArrowBackIcon fontSize="medium" />
    </IconButton>
  );
};

export default ArrowBackButton;
